/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiNodePathVisitor } from '../../visitors/AaiNodePathVisitor';

/**
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko<jsenko@redhat.com>
 * @class
 * @extends AaiNodePathVisitor
 */
export class Aai20NodePathVisitor extends AaiNodePathVisitor implements IAai20Visitor {
    public constructor() {
        super();
    }
}
Aai20NodePathVisitor["__class"] = "io.apicurio.datamodels.asyncapi.v2.visitors.Aai20NodePathVisitor";
Aai20NodePathVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor"];





import { IAai20Visitor } from './IAai20Visitor';

